import * as React from 'react';
import { Global, css } from '@emotion/react';
import { normalize } from 'polished';
import theme from './theme';

const GlobalStyles = () =>  (
    <React.Fragment>
        <Global
            styles={css`
            
            ${normalize()};

            * {
                /* outline: 1px solid red !important; */ /* debug box */
            }
        
            html,
            body {
                height: 100%;
            }
        
            #___gatsby {
                height: 100%;
                
                > div {
                    height: 100%;
                }
            }
        
            body {
                min-width: ${theme.breakpoints.phone}px;
                font-family: ${theme.typography.body.fontFamily.join(', ')};
                font-size: ${theme.typography.body.fontSize};
                font-weight: ${theme.typography.body.fontWeight};
                line-height: ${theme.typography.body.lineHeight};
                color: ${theme.colors.text};
            }
        
            strong {
                font-weight: ${theme.typography.body.boldFontWeight};
            }
        
            a {
                color: ${theme.colors.link};
                text-decoration: none;
        
                &:link,
                &:visited,
                &:hover,
                &:active {
                    color: ${theme.colors.link};
                }
            }
        
            li {
                padding-bottom: 10px;
                padding-left: 5px;
            }
            
            ul {
                padding-left: 20px;
            }
            
            hr {
                background-color: #dddddd; 
                height: 1px; 
                border: 0;
            }
            
            input, textarea, select {
                border:1px solid #cdcdcd;
                border-radius: 5px;
                font-family: ${theme.typography.body.fontFamily.join(', ')};
                color: ${theme.colors.text};
                font-weight: ${theme.typography.body.fontWeight};
                height: 30px;
            }
            `}
        />
    </React.Fragment>
);

export default GlobalStyles;